import styled from 'styled-components';

const Slide = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default Slide;
